import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface FlagFilterDatepickerProps {
  labelText: string;
  id: string;
  selected: Object;
  onChange: () => void;
  placeholder: string;
  isClearable: boolean;
}

function FlagFilterDatepicker({
  labelText,
  id,
  selected,
  onChange,
  placeholder,
  isClearable
}: FlagFilterDatepickerProps) {
  return (
    <>
      {labelText}
      <DatePicker
        id={id}
        selected={selected}
        onChange={onChange}
        placeholderText={placeholder}
        isClearable={isClearable}
      />
    </>
  );
}

export default FlagFilterDatepicker;
